/**
 * Design System Getproof - Button Component
 * Composant bouton basé sur l'analyse du code existant
 */

import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ButtonProps } from './Button.types';
import { 
  buttonStyles, 
  loadingStyles, 
  fullWidthStyles,
  iconStyles 
} from './Button.styles';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      loading = false,
      leftIcon,
      rightIcon,
      fullWidth = false,
      children,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || loading;

    return (
      <button
        ref={ref}
        className={cn(
          buttonStyles.base,
          buttonStyles.variants[variant],
          buttonStyles.sizes[size],
          fullWidth && fullWidthStyles,
          className
        )}
        disabled={isDisabled}
        {...props}
      >
        {/* Icône de gauche ou spinner de chargement */}
        {loading ? (
          <Loader2 
            className={cn(
              loadingStyles.spinner,
              loadingStyles.spinnerSizes[size]
            )} 
          />
        ) : leftIcon ? (
          <span className={iconStyles.left}>
            {leftIcon}
          </span>
        ) : null}

        {/* Contenu du bouton */}
        {children && (
          <span>
            {children}
          </span>
        )}

        {/* Icône de droite (seulement si pas de chargement) */}
        {!loading && rightIcon && (
          <span className={iconStyles.right}>
            {rightIcon}
          </span>
        )}
      </button>
    );
  }
);

Button.displayName = 'Button';